/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type CognitoUser,
    CognitoUserFromJSON,
    CognitoUserToJSON,
} from '../models/CognitoUser';

export interface ApproveUserRequest {
    /**
     * 
     */
    username: string;
}

export interface AssignRoleRequest {
    /**
     * 
     */
    username: string;
    /**
     * 
     */
    group: string;
}

export interface GetUserRequest {
    /**
     * 
     */
    username: string;
}

export interface RejectUserRequest {
    /**
     * 
     */
    username: string;
}

/**
 * 
 */
export class AdminControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for approveUser without sending the request
     */
    async approveUserRequestOpts(requestParameters: ApproveUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['username'] == null) {
            throw new runtime.RequiredError(
                'username',
                'Required parameter "username" was null or undefined when calling approveUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/admin/users/{username}/approve`;
        urlPath = urlPath.replace('{username}', encodeURIComponent(String(requestParameters['username'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async approveUserRaw(requestParameters: ApproveUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CognitoUser>> {
        const requestOptions = await this.approveUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CognitoUserFromJSON(jsonValue));
    }

    /**
     */
    async approveUser(requestParameters: ApproveUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CognitoUser> {
        const response = await this.approveUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for assignRole without sending the request
     */
    async assignRoleRequestOpts(requestParameters: AssignRoleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['username'] == null) {
            throw new runtime.RequiredError(
                'username',
                'Required parameter "username" was null or undefined when calling assignRole().'
            );
        }

        if (requestParameters['group'] == null) {
            throw new runtime.RequiredError(
                'group',
                'Required parameter "group" was null or undefined when calling assignRole().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['group'] != null) {
            queryParameters['group'] = requestParameters['group'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/admin/users/{username}/role`;
        urlPath = urlPath.replace('{username}', encodeURIComponent(String(requestParameters['username'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async assignRoleRaw(requestParameters: AssignRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CognitoUser>> {
        const requestOptions = await this.assignRoleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CognitoUserFromJSON(jsonValue));
    }

    /**
     */
    async assignRole(requestParameters: AssignRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CognitoUser> {
        const response = await this.assignRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAllUsers without sending the request
     */
    async getAllUsersRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/admin/users`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAllUsersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CognitoUser>>> {
        const requestOptions = await this.getAllUsersRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CognitoUserFromJSON));
    }

    /**
     */
    async getAllUsers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CognitoUser>> {
        const response = await this.getAllUsersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPendingUsers without sending the request
     */
    async getPendingUsersRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/admin/users/pending`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPendingUsersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CognitoUser>>> {
        const requestOptions = await this.getPendingUsersRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CognitoUserFromJSON));
    }

    /**
     */
    async getPendingUsers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CognitoUser>> {
        const response = await this.getPendingUsersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getUser without sending the request
     */
    async getUserRequestOpts(requestParameters: GetUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['username'] == null) {
            throw new runtime.RequiredError(
                'username',
                'Required parameter "username" was null or undefined when calling getUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/admin/users/{username}`;
        urlPath = urlPath.replace('{username}', encodeURIComponent(String(requestParameters['username'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getUserRaw(requestParameters: GetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CognitoUser>> {
        const requestOptions = await this.getUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CognitoUserFromJSON(jsonValue));
    }

    /**
     */
    async getUser(requestParameters: GetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CognitoUser> {
        const response = await this.getUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for rejectUser without sending the request
     */
    async rejectUserRequestOpts(requestParameters: RejectUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['username'] == null) {
            throw new runtime.RequiredError(
                'username',
                'Required parameter "username" was null or undefined when calling rejectUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/admin/users/{username}/reject`;
        urlPath = urlPath.replace('{username}', encodeURIComponent(String(requestParameters['username'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async rejectUserRaw(requestParameters: RejectUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CognitoUser>> {
        const requestOptions = await this.rejectUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CognitoUserFromJSON(jsonValue));
    }

    /**
     */
    async rejectUser(requestParameters: RejectUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CognitoUser> {
        const response = await this.rejectUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
